module.exports = __webpack_public_path__ + "static/media/popup_loadapp-05.b57bf530.png";